import * as React from 'react';
import * as _ from 'lodash';
import { FilterGroupValuesList } from './../../components/Filters/FilterGroupValuesList';
export default function () {
    function onBlur1() {
        this.handleBlur();
    }
    function onClick2(e) {
        this.close(e);
    }
    function onClick3(e) {
        this.toggleMarkupView(e);
    }
    return this.state.expanded ? React.createElement('div', {
        'className': _.transform({
            'stone-filter-panel': true,
            'stone-filter-panel-closed': !this.state.isMarkupExpanded
        }, function (res, value, key) {
            if (value) {
                res.push(key);
            }
        }, []).join(' '),
        'onBlur': onBlur1.bind(this),
        'tabIndex': '0',
        'key': '102'
    }, React.createElement('div', {
        'className': 'stone-filter-close-button',
        'onClick': onClick2.bind(this)
    }), React.createElement('div', {
        'className': _.transform({
            'stone-filter-content-wrapper': true,
            'stone-filter-content-wrapper--single': this.props.type !== 'materials'
        }, function (res, value, key) {
            if (value) {
                res.push(key);
            }
        }, []).join(' ')
    }, React.createElement('div', { 'className': 'stone-filter-col-1-wrapper' }, React.createElement(FilterGroupValuesList, {
        'filterItems': this.props.items,
        'checkedItems': this.props.checked,
        'handleFilterClick': this.props.handleFilterClick,
        'type': this.props.type
    }), this.props.type === 'materials' && !this.props.hideMarkUpDown ? React.createElement('div', {
        'className': 'green-button-inputs green-button-inputs-disabled',
        'onClick': onClick3.bind(this),
        'key': '2103'
    }, 'Mark Up / Down') : null), this.props.type === 'materials' ? React.createElement('div', {
        'className': 'stone-filter-col-2',
        'key': '2328'
    }, React.createElement('h2', {}, 'Change Price Percentage'), React.createElement('div', { 'className': 'radio-wrapper' }, React.createElement('div', { 'className': 'radio-ring' }, React.createElement('div', { 'className': 'radio-check' })), React.createElement('h1', {}, 'Mark-up')), React.createElement('div', { 'className': 'radio-wrapper' }, React.createElement('div', { 'className': 'radio-ring' }, React.createElement('div', {
        'className': 'radio-check',
        'style': { display: 'none' }
    })), React.createElement('h1', {}, 'Mark-down')), React.createElement('input', {
        'className': 'generic-popup-textbox',
        'placeholder': 'Enter Mark-down Percentage'
    }), React.createElement('div', { 'className': 'green-button-inputs' }, 'Add Mark Up / Down'), React.createElement('div', { 'className': 'stone-dashed-line' })) : null)) : null;
}